// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import ProfileDeleteModal from './ProfileDeleteModal'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import Password from 'components/Form/Password'
import Badge from 'components/Badge/Badge'

// Redux:
import { updateAccount, deleteAccount, getAccountLikesData } from 'actions/site'

class Profile extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			formState: '',
			changed: false,
			updated: false,
			updating: false,
			userName: '',
			email: '',
			password: '',
			passwordHasError: false,
			confirmDeleteAccount: false,
			deletingAccount: false
		}

		this.state = state
	}

	componentDidMount() {
		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		const { accountData, dispatch } = this.props

		if ( accountData && accountData.email ) {
			this.setState( {
				userName: accountData.name,
				email: accountData.email,
				password: '',
				changed: false
			} )
		}

		dispatch( getAccountLikesData() )
	}

	componentDidUpdate( prevProps ) {
		const { accountData } = this.props
		const { updating } = this.state

		if ( accountData && accountData.email && prevProps.accountData !== accountData ) {
			this.setState( {
				userName: accountData.name,
				email: accountData.email,
				password: '',
				changed: false
			} )
		}

		if ( updating && accountData && accountData.updated_at && prevProps.accountData.updated_at !== accountData.updated_at ) {
			this.setState( {
				updating: false,
				formState: 'is-processed'
			} )

			setTimeout( () => {
				this.setState( {
					formState: 'is-successful'
				} )

				setTimeout( () => {
					this.setState( {
						formState: '',
						updated: true
					} )
				}, 1000 )
			}, 1000 )
		}

		if ( accountData && accountData.deleted && ! prevProps.accountData.deleted ) {
			this.setState( {
				deletingAccount: false,
				accountDeleted: true
			} )
		}
	}

	handleChange = ( e ) => {
		const target = e.target
		const name = target.name
		const value = target.type === 'checkbox' ? target.checked : target.value

		this.setState( {
			changed: true,
			[ name ]: value
		} )
	}

	handlePasswordChange = ( id, value ) => {
		this.setState( {
			changed: true,
			password: value
		} )
	}

	handlePasswordError = ( id, value ) => {
		this.setState( {
			passwordHasError: value
		} )
	}

	handleSubmit = ( e ) => {
		e.preventDefault()

		const { dispatch, accountData } = this.props
		const { userName, email, password, passwordHasError } = this.state

		if ( passwordHasError ) {
			return
		}

		this.setState( {
			updated: false,
			updating: true,
			formState: 'is-processing'
		} )

		const userMetadata = {
			name: userName,
			email
		}

		if ( password ) {
			userMetadata.password = password
		}

		dispatch( updateAccount( userMetadata ) )
	}

	handleClickDeleteAccount = ( e ) => {
		e.preventDefault()

		this.setState( {
			confirmDeleteAccount: true
		} )
	}

	handleConfirmDeleteAccount = () => {
		const { dispatch } = this.props

		dispatch( deleteAccount() )

		this.setState( {
			deletingAccount: true,
			confirmDeleteAccount: false
		} )
	}

	handleCancelDeleteAccount = () => {
		this.setState( {
			confirmDeleteAccount: false
		} )
	}

	renderBadges = () => {
		const { accountData } = this.props
		const allBadges = [
			'listen_3_hours',
			'listen_25_hours',
			'listen_100_hours',
			'donate',
			'donate_recurring',
			'record_votd'
		]
		let attainedBadgesKeys = []
		let badgesMarkup,
			otherBadgesMarkup

		if ( accountData && accountData.badges && Object.keys( accountData.badges ).length ) {
			attainedBadgesKeys = Object.keys( accountData.badges )
			badgesMarkup = attainedBadgesKeys.map( key => {
				return <Badge key={ key } badgeId={ key } isMedium={ true } withText={ true } />
			} )
		}

		otherBadgesMarkup = allBadges.map( key => {
			if ( attainedBadgesKeys.includes( key ) ) {
				return
			}

			return <Badge key={ key } badgeId={ key } isMedium={ true } withText={ true } isUnattained={ true } />
		} )

		return (
			<div>
				<h2>My badges</h2>

				<div className="-badges">
					{ badgesMarkup }
					{ otherBadgesMarkup }
				</div>
			</div>
		)
	}

	render() {
		const { accountData } = this.props
		let {
			userName, email, password,
			formState, updating, updated, changed, passwordHasError,
			confirmDeleteAccount, deletingAccount, accountDeleted
		} = this.state
		let buttonText = updated && ! changed ? 'Updated': 'Update'
		let buttonClass = updating ? 'button is-loading' : 'button'
		let buttonDisabled = ! changed
		let emailDisabled = false
		let emailNote = ''
		const className = `form ${formState}`
		let showForm = true

		if ( passwordHasError ) {
			buttonDisabled = true
		}

		if ( ! accountData ) {
			return null
		}

		if ( password ) {
			email = accountData.email
			emailDisabled = true
			emailNote = '(Email and password cannot be changed together)'
		}

		if ( deletingAccount || accountDeleted ) {
			showForm = false
		}

		let likedProgramsNumber = 0

		if ( accountData && accountData.likes ) {
			likedProgramsNumber = Object.keys( accountData.likes ).length
		}

		return (
			<div className="profile-page">
				{ confirmDeleteAccount && <ProfileDeleteModal handleAccept={ this.handleConfirmDeleteAccount } handleCancel={ this.handleCancelDeleteAccount } /> }

				{ deletingAccount && <LoadingSpinner /> }

				{ accountDeleted &&
					<div className="callout">
						<p>Your account has been deleted.</p>
					</div>
				}

				{ updated && ! updating &&
					<div className="callout">
						<p>Your profile has been updated.</p>
					</div>
				}

				{ showForm &&
					<form className={ className } onSubmit={ this.handleSubmit }>
						{ accountData.can_change_profile &&
							<div>
								<div className="form-item form-text">
									<label htmlFor="userName">Name</label>

									<input type="text" name="userName" value={ userName } onChange={ this.handleChange } />
								</div>

								<div className="form-item form-text">
									<label htmlFor="email">Email <span className="form-lable-note">{ emailNote }</span></label>

									<input type="email" name="email" value={ email } onChange={ this.handleChange } disabled={ emailDisabled } />
								</div>

								<Password
									label="Password (leave blank for no change)"
									value={ password }
									onChange={ this.handlePasswordChange }
									handleError={ this.handlePasswordError }
									allowBlank={ true }
								/>
							</div>
						||
							<div>
								<h4>Name</h4>
								<p>{ userName }</p>

								<h4>Email</h4>
								<p>{ email }</p>
							</div>
						}

						{ accountData.can_change_profile &&
							<div className="form-actions">
								<div className="form-action-primary">
									<button type="submit" className={ buttonClass } disabled={ buttonDisabled }>{ buttonText }</button>
								</div>
							</div>
						}
					</form>
				}

				{ this.renderBadges() }

				{ ( !! likedProgramsNumber ) &&
					<div className="-profile-favourites">
						<h2>Favourites</h2>

						<p>
							You have { likedProgramsNumber } episodes in your favourites.
						</p>

						<p>
							<Link to="/favourites" className="button">View my favourites</Link>
						</p>
					</div>
				}

				<div className="-profile-delete">
					<h2>Delete account</h2>

					<p>
						Please note that once your account is deleted you will lose all your badges (with their ability to listen to future and past programs).<br />
						This cannot be undone.
					</p>

					<p>
						<button type="button" className="button" onClick={ this.handleClickDeleteAccount }>Delete account</button>
					</p>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.site.accountData
	}
}

export default connect( mapStateToProps )( Profile )
